export default __webpack_public_path__ + "images/b17f506b8dd16b1a437aa222c6d90320-basketball.png";